import React, { useCallback, useState } from 'react';
import SiteHeader from './components/SiteHeader';
import Banner from './components/Banner';
import NoticeView from './components/NoticeView';
import JobsView from './components/JobsView';
import ApplyModal from './components/ApplyModal';
import { getApplyUrl, isMobileDevice } from './utils/getApplyUrl';

const VIEW_TITLES = {
  'notice-view': '中邮资管社会招聘·招聘公告',
  'jobs-view': '中邮资管社会招聘·招聘岗位',
};

function App() {
  const [activeView, setActiveView] = useState('notice-view');
  const [applyModal, setApplyModal] = useState({
    open: false,
    targetUrl: '',
    mobile: false,
  });

  const handleChangeView = useCallback((viewId) => {
    setActiveView(viewId);
    document.title = VIEW_TITLES[viewId] || '中邮资管社会招聘';
    document.getElementById('page-switcher')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }, []);

  const handleApply = useCallback((jobId) => {
    const mobile = isMobileDevice();
    const target = getApplyUrl(jobId, mobile);
    if (!target) return;
    setApplyModal({ open: true, targetUrl: target, mobile });
  }, []);

  const handleCloseApplyModal = useCallback(() => {
    setApplyModal({ open: false, targetUrl: '', mobile: false });
  }, []);

  return (
    <>
      <SiteHeader activeView={activeView} onChangeView={handleChangeView} />
      <Banner />
      <NoticeView hidden={activeView !== 'notice-view'} />
      <JobsView hidden={activeView !== 'jobs-view'} onApply={handleApply} />
      <ApplyModal
        open={applyModal.open}
        targetUrl={applyModal.targetUrl}
        mobile={applyModal.mobile}
        onClose={handleCloseApplyModal}
      />
    </>
  );
}

export default App;
